import { render, staticRenderFns } from "./EventsScoredList.vue?vue&type=template&id=c9f72d9e"
import script from "./EventsScoredList.vue?vue&type=script&lang=js"
export * from "./EventsScoredList.vue?vue&type=script&lang=js"
import style0 from "./EventsScoredList.vue?vue&type=style&index=0&id=c9f72d9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports